module.exports = __webpack_public_path__ + "img/travel_distance_icon.104c139e.png";